import React from "react";

interface ShowWhenProps {
  when: any; // Change the type to 'any' to allow any type to be passed
  children: React.ReactNode; // Use 'React.ReactNode' for the children prop
}

export const ShowWhen = (props: ShowWhenProps) => {
  const { when, children } = props;

  // Use type coercion to check if 'when' is truthy
  if (!when) return null; // Return 'null' to render nothing if 'when' is falsy

  return <>{children}</>;
};
